// src/hooks/useOrderActions.js
import { useCallback } from 'react';
import config from '../config';

const host = config.backendUrl

export default function useOrderActions(order, setOrder, authToken) {
  const terminateOrder = useCallback(() => {
    if (!order || !order.id) return;
    if (window.confirm('Are you sure you want to cancel this order?')) {
      fetch(`${host}/api/admin/terminate-order/${order.id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((res) => res.json())
        .then(() => {
          alert('Order Cancelled');
          window.location.href = '/orders';
        })
        .catch((err) => console.error('Terminate order failed:', err));
    }
  }, [order, authToken]);

  const updateStatus = useCallback(() => {
    if (!order || !order.id) return;
    const newStatus = prompt('Enter new status:', order.status);
    if (newStatus) {
      fetch(`${host}/api/admin/update-status/${order.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ status: newStatus }),
      })
        .then((res) => res.json())
        .then(() => {
          alert('Status updated');
          setOrder((prev) => ({ ...prev, status: newStatus }));
        })
        .catch((err) => console.error('Update status failed:', err));
    }
  }, [order, authToken, setOrder]);

  const updateOrderNote = useCallback((note) => {
    if (!order || !order.id) return;
    fetch(`${host}/api/admin/update-value/${order.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ path: 'notes', value: note }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'success') {
          setOrder((prev) => ({ ...prev, notes: note }));
          alert('Note updated successfully');
        } else {
          alert('Failed to update note');
        }
      })
      .catch((err) => console.error('Update note failed:', err));
  }, [order, authToken, setOrder]);

  return {
    terminateOrder,
    updateStatus,
    updateOrderNote,
  };
}